<template>
  <el-dialog
    title="风险处理详情"
    :visible.sync="dialogVisible"
    :width="isHandled ? '1200px' : '800px'"
    append-to-body
    class="dialog"
    @open="onOpen"
  >
    <div class="flex col-top">
      <div class="left" :class="{'no-handle': !isHandled}">
        <div class="card">
          <div class="section">
            <div class="section-title">
              <base-section-title title="风险详情" />
            </div>
            <div class="section-content">
              <div class="m-b-6">风险描述：{{ detailInfo.riskContent }}</div>
              <el-descriptions size="medium" :column="1" border>
                <el-descriptions-item
                  label="风险涉及对象"
                  :label-style="{ width: '200px' }"
                >
                  <look-text-more
                    :maxlength="200"
                    :content="detailInfo.triggerValues"
                  />
                </el-descriptions-item>
                <el-descriptions-item
                  label="命中风险详情"
                  :label-style="{ width: '200px' }"
                >
                  <look-text-more
                    :maxlength="300"
                    :content="detailInfo.riskDesc"
                  />
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
        </div>

        <div v-if="isHandled" class="card">
          <div class="section">
            <div class="section-title">
              <base-section-title title="处理详情" />
            </div>
            <div class="section-content">
              <jczh-descriptions
                :info="detailInfo"
                :option="infoOption"
                :el-attrs="{
                  size: 'medium',
                  column: 2,
                  labelStyle: {
                    whiteSpace: 'nowrap'
                  }
                }"
              >
                <template v-slot:file>
                  <upload
                    style="width:500px;"
                    :file-id-before.sync="detailInfo.files"
                    :props-data="{
                      uploadMode: 'fileId',
                      disabled: true
                    }"
                  />
                </template>
              </jczh-descriptions>
            </div>
          </div>
        </div>
      </div>

      <el-divider v-if="isHandled" direction="vertical" />

      <risk-company-list v-if="isHandled" class="flex-1" :order-monitor-id="monitorId" />
    </div>
  </el-dialog>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload'
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import LookTextMore from '@/components/risk/LookTextMore'
import RiskCompanyList from '@/components/risk/RiskCompanyList'

// 数据字典
import {
  riskHandleStatusDict,
  riskPointsDict
} from '@/dictionary/risk'

// 后端api
import { getRiskHandleDetailApi } from '@/api/risk/manage'

export default {
  name: 'RiskHandleDetailDialog',
  components: {
    Upload,
    BaseSectionTitle,
    LookTextMore,
    RiskCompanyList
  },

  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * 操作行数据
     */
    rowData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      detailInfo: {},
      infoOption: [
        {
          label: '是否确认风险',
          prop: 'processStatus',
          filter: (value) => {
            return riskHandleStatusDict.translate(value)?.radioLabel || ''
          },
          useTag: true,
          elAttrs: { span: 2 }
        },
        {
          label: '处理说明',
          prop: 'handleReason',
          elAttrs: { span: 2 }
        },
        {
          label: '处理人',
          prop: 'handlerEmpName',
          elAttrs: { span: 2 }
        },
        {
          label: '处理人所属企业',
          prop: 'handlerCompanyName',
          elAttrs: { span: 2 }
        },
        {
          label: '确认时间',
          prop: 'handleTime',
          elAttrs: { span: 2 }
        },
        {
          label: '佐证材料',
          prop: 'files',
          slotName: 'file',
          elAttrs: { span: 2 }
        }
      ]
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('change', val)
      }
    },

    // 风险是否已处理
    isHandled() {
      return (
        this.detailInfo?.processStatus === riskHandleStatusDict.CONFIRM.value ||
        this.detailInfo?.processStatus === riskHandleStatusDict.SECURE.value
      )
    },

    monitorId() {
      return this.rowData?.monitorId || ''
    }
  },
  methods: {
    onOpen() {
      this.$nextTick(() => {
        this.getDetail()
      })
    },

    getDetail() {
      getRiskHandleDetailApi(this.rowData.monitorId)
        .then(res => {
          const data = res?.data || {}
          const descObj = riskPointsDict.translate(data?.monitorInfo?.riskCode)
          this.detailInfo = {
            ...data,
            triggerValues: (data?.riskTriggers || [])
              .map(item => item.triggerValue)
              .join(','),
            riskDesc: descObj.getContent
              ? descObj.getContent(
                  data?.monitorInfo?.orderName,
                  data?.riskTriggers || [],
                  data?.monitorInfo?.monitorValue
              ) || ''
              : ''
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.left {
  flex: 0 0 650px;
  width: 650px;

  &.no-handle {
    flex: 1;
  }
}
::v-deep .el-divider--vertical {
  height: 500px;
  flex: 0 0 1px;
  background-color: $info-fourth-color;
}
</style>
